import { render, staticRenderFns } from "./StockRequestView.vue?vue&type=template&id=12c49cee"
import script from "./StockRequestView.vue?vue&type=script&lang=js"
export * from "./StockRequestView.vue?vue&type=script&lang=js"
import style0 from "./StockRequestView.vue?vue&type=style&index=0&id=12c49cee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports